module.exports = __webpack_public_path__ + "static/media/CTLI_3-235w.094949bd.webp";